<template>

    <div class="modal fade" id="invoicesModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content" v-if="selectedElement !== null">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                    <h4 v-if="selectedElement.isTask === true" class="modal-title">Projectfacturen voor taak {{ selectedElement.task }} in project {{ selectedElement.project }}</h4>
                    <h4 v-else class="modal-title">Facturen voor contact {{ selectedElement.name }}</h4>
                </div>
                <div class="modal-body" v-if="editinvoice !== true">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Verzonden</th>
                                <th>Verwacht</th>
                                <th v-if="!selectedElement.purchaseinvoices">Betaaltermijn</th>
                                <th>Referentie</th>
                                <th>Factuurnummer</th>
                                <th>Factuurdatum</th>
                                <th>Contact</th>
                                <th>Verschotten</th>
                                <th>Bedrag</th>
                                <th>Totaal (excl)</th>
                                <th>Totaal (incl)</th>
                                <th>Voldaan</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="selectedElement.invoices.length === 0">
                                <td colspan="12">Er zijn geen facturen gevonden</td>
                            </tr>
                            <tr v-for="invoice in selectedElement.invoices" :class="{'bg-success':clickedElement !== null && invoice.uuid === clickedElement.uuid}">
                                <td>
                                    <i v-if="invoice.description !== null && invoice.description !== ''" class="mdi mdi-information" v-tooltip="invoice.description"></i>
                                    {{ invoice.send ? 'Ja' : 'Nee' }}
                                </td>
                                <td>{{ invoice.expected_at }}</td>
                                <td v-if="!selectedElement.purchaseinvoices">{{ invoice.paymentterm }} dagen</td>
                                <td>{{ invoice.po_number }}</td>
                                <td>{{ invoice.invoice_nr }}</td>
                                <td>{{ invoice.date }}</td>
                                <td>{{ invoice.contact }}</td>
                                <td>{{ invoice.expenses | toCurrency }}</td>
                                <td>{{ invoice.amount | toCurrency }}</td>
                                <td>{{ invoice.sub_total | toCurrency }}</td>
                                <td>{{ invoice.total | toCurrency }}</td>
                                <td>{{ invoice.paid ? 'Ja (' + invoice.paid_at + ')' : 'Nee' }}</td>
                                <td>
                                    <button class="btn btn-default btn-xs" @click="selectInvoiceToEdit(invoice)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-body" v-if="editinvoice === true">
                    <button class="btn btn-info btn-sm" @click="resetForm()">&laquo; Terug naar overzicht</button>
                </div>
                <div class="modal-body" v-if="editinvoice === true">
                    <div class="row" v-if="invoicesCanBeCreated === true">
                        <div class="col-sm-6">
                            <h4>Document</h4>
                            <div v-if="null === invoice.paths.documenturl" class="margin-bottom">
                                <div v-if="selectedElement.purchaseinvoices && selectedElement.purchaseinvoices === true" class="margin-bottom">
                                    <div class="form-group" style="max-width:60%;">
                                        <p class="form-control-static">Selecteer een document uit de onderstaande lijst om te koppelen:</p>
                                        <v-select id="pendingdocuments"
                                            :options="selectedElement.pendingdocuments"
                                            v-model="pendingdoc"
                                            label="name"
                                        ></v-select>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-primary btn-sm" :disabled="cantAttach" @click="attachDocument">Koppel</button>
                                    </div>
                                </div>
                                <p v-else class="form-control-static">Er is geen document gekoppeld aan deze factuur.</p>
                            </div>
                            <div v-else class="margin-bottom">
                                <p class="form-control-static">Klik op de onderstaande knop om het factuur document in een nieuw venster te openen.</p>
                                <div class="btn-group btn-group-sm">
                                    <a :href="invoice.paths.documenturl" class="btn btn-primary" target="_blank" v-tooltip="'Document openen'">Document openen</a>
                                    <button v-if="invoice.salesinvoice === false" class="btn btn-danger" @click="detachDocument">Koppeling verwijderen</button>
                                </div>
                                <div class="btn-group btn-group-sm">
                                    <a
                                        :href="invoice.paths.documenturl_preview"
                                        target="_blank"
                                        class="btn btn-primary"
                                        v-tooltip="'Document downloaden'"
                                    >
                                        <i class="mdi mdi-open-in-app"></i>
                                    </a>
                                </div>
                                <div v-if="invoice.paths.ublurl != null" class="btn-group btn-group-sm align-right">
                                    <a :href="invoice.paths.ublurl" class="btn btn-primary" target="_blank"
                                       v-tooltip="'E-factuur openen'">E-factuur openen</a>
                                </div>
                                <div v-if="invoice.paths.ublurl_preview != null" class="btn-group btn-group-sm align-right">
                                    <a
                                        :href="invoice.paths.ublurl_preview"
                                        target="_blank"
                                        class="btn btn-primary"
                                        v-tooltip="'E-factuur downloaden'"
                                    >
                                        <i class="mdi mdi-open-in-app"></i>
                                    </a>
                                </div>
                            </div>
                            <h4 style="margin-top:20px;">Factuur gegevens</h4>
                            <div class="form-horizontal">
                                <div class="form-group">
                                    <div class="alert alert-info" style="margin-left:20px;margin-right:20px;"
                                        v-if="invoiceoriginal.created === true && invoiceoriginal.taxpercentage !== parseInt(invoice.taxpercentage)"
                                    >
                                        <p><strong>Let op:</strong> Na het aanpassen van het BTW percentage, zal de aangemaakte factuur <u>niet</u> opnieuw gegenereerd worden.</p>
                                    </div>
                                    <div class="row">
                                        <label class="control-label col-sm-3">BTW percentage:</label>
                                        <div class="col-sm-9">
                                            <div class="input-group" style="width:120px;">
                                                <input type="number" class="form-control"
                                                    :disabled="!canEditInvoiceFields"
                                                    v-model="invoice.taxpercentage"
                                                />
                                                <span class="input-group-addon">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="invoice.salesinvoice === true">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Betaaltermijn:</label>
                                        <div class="col-sm-9">
                                            <div class="input-group" style="width:120px;">
                                                <input type="text" class="form-control"
                                                    :disabled="!canEditInvoiceFields"
                                                    v-model="invoice.paymentterm"
                                                />
                                                <span class="input-group-addon">dagen</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="control-label col-sm-3">PO nummer:</label>
                                        <div class="col-sm-9">
                                            <div style="width:120px;">
                                                <input type="text" class="form-control"
                                                    v-model="invoice.po_number"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-info" style="margin-left:20px;margin-right:20px;"
                                        v-if="invoiceoriginal.created === true && invoice.amount !== invoiceoriginal.amount"
                                    >
                                        <p><strong>Let op:</strong> Na het aanpassen van het totaalbedrag, zal de aangemaakte factuur <u>niet</u> opnieuw gegenereerd worden.</p>
                                    </div>
                                    <div class="row">
                                        <label class="control-label col-sm-3">Bedrag (Excl. BTW):</label>
                                        <div class="col-sm-9">
                                            <money
                                                style="width:200px;"
                                                class="form-control"
                                                ref="moneyElement"
                                                :disabled="!canEditInvoiceFields"
                                                :value="getProperAmount(invoice)"
                                                @input="setProperAmount($event, invoice)"
                                                v-bind="money"
                                            ></money>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Verschotten (Excl. BTW):</label>
                                        <div class="col-sm-9">
                                            <money
                                                style="width:200px;"
                                                class="form-control"
                                                ref="moneyElement"
                                                :disabled="!canEditInvoiceFields"
                                                :value="getProperExpenses(invoice)"
                                                @input="setProperExpenses($event, invoice)"
                                                v-bind="money"
                                            ></money>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="invoice.invoice_nr !== null">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Factuurnummer:</label>
                                        <div class="col-sm-9">
                                            <p class="form-control-static">{{ invoice.invoice_nr }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="invoice.created === true">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Factuurdatum:</label>
                                        <div class="col-sm-9">
                                            <date-picker
                                                v-if="invoice.send === false || invoice.salesinvoice === false"
                                                v-model="invoice.date"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                lang="en"
                                                style="max-width:200px;"
                                                size="small"
                                                :disabled="!canEditInvoiceFields"
                                            ></date-picker>
                                            <p v-else class="form-control-static">{{ moment(invoice.date).format("DD-MM-YYYY") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="invoice.salesinvoice === true">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Aangemaakt:</label>
                                        <div class="col-sm-9">
                                            <bootstrap-toggle
                                                v-model="invoice.created"
                                                :options="{ on: 'Ja', off: 'Nee', size:'small' }"
                                                :disabled="invoiceoriginal.created === true"
                                                size="small"
                                            />
                                            <small
                                                v-show="invoice.created === true && invoiceoriginal.created !== true"
                                                style="display: block;"
                                            >
                                                De factuur zal automatisch aangemaakt worden, wanneer deze nog niet bestaat!
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="control-label col-sm-3">
                                            <span v-if="invoice.created">Verwachte betaaldatum</span>
                                            <span v-else>Verwachte factuurdatum</span>
                                        </label>
                                        <div class="col-sm-9">
                                            <date-picker
                                                v-model="invoice.expected_at"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                lang="en"
                                                style="max-width:200px;"
                                                size="small"
                                                :disabled="invoiceoriginal.paid === true"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="control-label col-sm-3" v-text="invoice.salesinvoice === true ? 'Verzonden:' : 'Ontvangen:'" />
                                        <div class="col-sm-9">
                                            <bootstrap-toggle
                                                v-model="invoice.send"
                                                :options="{ on: 'Ja', off: 'Nee', size:'small' }"
                                                :disabled="invoiceoriginal.send === true || invoiceoriginal.created !== true"
                                                size="small"
                                                @input="invoiceSendClicked($event)"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Voldaan:</label>
                                        <div class="col-sm-9">
                                            <bootstrap-toggle
                                                v-model="invoice.paid"
                                                :options="{ on: 'Ja', off: 'Nee', size:'small' }"
                                                :disabled="invoiceoriginal.paid === true || invoiceoriginal.send !== true"
                                                size="small"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-show="invoice.paid === true">
                                    <div class="row">
                                        <label class="control-label col-sm-3">Voldaan op</label>
                                        <div class="col-sm-9">
                                            <date-picker
                                                v-model="invoice.paid_at"
                                                format="DD-MM-YYYY"
                                                type="date"
                                                lang="en"
                                                style="max-width:200px;"
                                                size="small"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <span class="col-sm-3">&nbsp;</span>
                                        <div class="col-sm-9">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <button class="btn btn-primary btn-sm"
                                                        :disabled="!canSubmit"
                                                        @click="onSubmit()"
                                                    >Factuurgegevens opslaan</button>
                                                </div>
                                                <div
                                                    class="col-sm-6 text-right"
                                                    v-if="canDeleteInvoice"
                                                >
                                                    <delete-button
                                                        :disabled="invoice.is_parent"
                                                        :url="invoice.paths.deleteinvoice"
                                                        :title="invoice.salesinvoice === true ? 'Factuur' : 'Inkoopnota'"
                                                        :name="(invoice.salesinvoice === true ? 'Factuur' : 'Inkoopnota') + ' van ' + invoice.contact"
                                                        v-tooltip="invoice.is_parent ? 'Kan factuur niet verwijderen, omdat er duplicaten van bestaan' : (invoice.salesinvoice === true ? 'Factuur verwijderen' : 'Inkoopnota verwijderen')"
                                                        @delete-completed="invoiceIsDeleted"
                                                    ></delete-button>
                                                </div>
                                                <div class="col-sm-6 text-right" v-if="invoice.send === true && invoice.paths.createcreditinvoice && invoice.salesinvoice === true">
                                                    <button class="btn btn-danger btn-sm" @click="creditInvoice()">Factuur crediteren</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div v-if="invoiceoriginal.notes" style="margin-top:20px;">
                                <h4>Interne notities</h4>
                                <div v-if="invoiceoriginal.notes.length === 0">
                                    <p>Er zijn geen notities toegevoegd aan deze nota</p>
                                </div>
                                <div v-for="note in invoiceoriginal.notes" class="invoicenote">
                                    <h5>{{ note.user }} op {{ moment(note.created_at).format("DD-MM-YYYY") }} om {{ moment(note.created_at).format("HH:mm") }} uur</h5>
                                    <p v-html="note.note"></p>
                                </div>
                            </div>
                            <div class="invoicenote">
                                <h4>Interne notitie toevoegen</h4>
                                <div class="form-group">
                                    <textarea
                                        class="form-control"
                                        v-model="note"
                                    ></textarea>
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-primary btn-sm"
                                        type="button"
                                        @click="saveNote()"
                                    >Notitie opslaan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h2>Factuur aanmaken niet mogelijk!</h2>
                        <p>Uw beheerder heeft Archibase nog niet correct ingesteld. Hierdoor is het momenteel nog niet mogelijk om facturen aan te maken!</p>
                        <p>Neem contact op met uw beheerder om dit probleem te verhelpen.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import BootstrapToggle from 'vue-bootstrap-toggle';
import moment from 'moment';
import Lang from '../../Lang';
import {Money} from 'v-money';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

export default {

    components: {
        BootstrapToggle,
        Money,
        vSelect,
        DatePicker,
    },

    computed:{

        canDeleteInvoice() {
            if (!this.invoice) {
                return false;
            }

            if (this.invoice.salesinvoice === true) {
                return this.invoice.send === false &&
                    this.invoice.created === false &&
                    this.invoice.paths.deleteinvoice;
            }

            return this.invoice.paid === false;
        },

        canEditInvoiceFields() {
            if (this.invoice.paid) {
                return false;
            }

            if (this.invoicesCanBeEdited === true || !this.invoice) {
                return true;
            }

            return this.invoice.send === false;
        },

        canSubmit(){
            if (!this.invoice || !this.invoiceoriginal) {
                return false;
            }

            if (this.invoiceoriginal.date === null &&
                this.invoice.created === false &&
                this.invoice.send === true &&
                this.invoice.paid === false &&
                this.invoice.date === null) {
                return false;
            }
            return !this.posting && (
                    this.invoiceoriginal.po_number !== this.invoice.po_number ||
                    this.invoiceoriginal.paymentterm !== this.invoice.paymentterm ||
                    this.invoiceoriginal.expenses !== this.invoice.expenses ||
                    this.invoiceoriginal.amount !== this.invoice.amount ||
                    this.invoiceoriginal.created !== this.invoice.created ||
                    this.invoiceoriginal.date !== this.invoice.date ||
                    this.invoiceoriginal.expected_at !== this.invoice.expected_at ||
                    this.invoiceoriginal.paid !== this.invoice.paid ||
                    this.invoiceoriginal.paid_at !== this.invoice.paid_at ||
                    this.invoiceoriginal.send !== this.invoice.send
                ) &&
                (this.invoice.paid !== true || this.invoice.paid_at !== null);
        },

        cantAttach() {
            return this.pendingdoc === null && this.posting === false;
        },

        postData() {
            let data = JSON.parse(JSON.stringify(this.invoice));
            let returndata = {
                uuid: data.uuid,
                taxpercentage: data.taxpercentage,
                paymentterm: data.paymentterm,
                amount: data.amount,
                expenses: data.expenses,
                created: data.created,
                send: data.send,
                paid: data.paid,
                date: data.date !== null ? moment(data.date).format("YYYY-MM-DD") : null,
                expected_at: moment(data.expected_at).format("YYYY-MM-DD"),
                paid_at: data.paid_at !== '' ? moment(data.paid_at).format("YYYY-MM-DD") : null,
                po_number: data.po_number,
            };

            return returndata;
        },

    },

    data() {
        return {
            clickedElement:null,
            editinvoice:false,
            invoice: {},
            invoiceoriginal:null,
            invoicesCanBeCreated:false,
            invoicesCanBeEdited:false,
            moment:moment,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            note:'',
            pendingdoc:null,
            posting:false,
            selectedElement:null,
        }
    },

    methods: {

        attachDocument() {
            if (this.cantAttach) {
                return;
            }
            this.posting = true;
            axios.post(this.invoiceoriginal.paths.attachdocument, {
                invoice_uuid:this.invoiceoriginal.uuid,
                document_uuid:this.pendingdoc.uuid,
            })
            .then(resp => {
                this.invoice.paths.documenturl = resp.data.data.documenturl;
                this.$snotify.success("Het document is aan deze nota gekoppeld");
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het koppelen van het document"))
            .finally(() => this.posting = false);
        },

        setInvoiceOptions() {
            axios.get(this.route('api.v1.invoices'))
            .then(resp => {
                this.invoicesCanBeCreated = resp.data.created;
                this.invoicesCanBeEdited = resp.data.edited;
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het ophalen van de gegevens"));
        },

        closeInvoicesModal() {
            $('#invoicesModal').modal('hide');
        },

        creditInvoice() {
            if (this.posting === true) {
                return;
            }
            if (!confirm("Weet je zeker dat deze nota gecrediteerd moet worden?")) {
                return false;
            }
            this.posting = true;
            axios.post(this.invoiceoriginal.paths.createcreditinvoice)
            .then(resp => {
                console.log(resp.data);
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het aanmaken van de creditnota"))
            .finally(() => this.posting = false);
        },

        detachDocument() {
            this.posting = true;
            axios.post(this.invoiceoriginal.paths.detachdocument)
                .then(() => {
                    this.invoice.paths.documenturl = null;
                    this.$snotify.success('Het document is losgekoppeld')
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het loskoppelen van het document'))
                .finally(() => this.posting = false);
        },

        getProperAmount(invoice) {
            return invoice.amount / 100;
        },

        getProperExpenses(invoice) {
            return invoice.expenses / 100;
        },

        invoiceIsDeleted() {
            this.selectedElement.invoices.splice(this.selectedElement.invoices.findIndex(invoice => invoice.uuid === this.invoice.uuid), 1);
            this.$emit("invoice-deleted-uuid", this.invoice.uuid);

            this.resetForm();
        },

        onSubmit() {
            if (false === this.canSubmit) {
                return;
            }
            this.posting = true;
            axios.post(this.invoiceoriginal.paths.update, this.postData)
            .then(resp => {
                // Snotify
                this.$snotify.success("De factuurgegevens zijn aangepast");
                this.$snotify.info("Wanneer een factuur aangemaakt moet worden, kan dit enkele momenten duren");
                // Store the new invoice
                let newinvoice = resp.data.data.invoice;
                // Replace the old record
                this.selectedElement.invoices[this.selectedElement.invoices.findIndex(inv => inv.uuid === newinvoice.uuid)] = newinvoice;
                // Stop posting
                this.posting = false;
                // Reset the form
                this.resetForm();
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het opslaan van de factuurgegevens"));
        },

        invoiceSendClicked(value) {
            if (value === true && (this.invoice.date === null || this.invoice.date.toString() === "Invalid Date")) {
                this.invoice.date = moment().toDate();
            }
        },

        openModal(url, options = {}, clickedElement = null) {
            this.editinvoice = false;
            // We need to make an API call to get all Invoices for the given task uuid. If we'd use the results from
            // the this.tasks.invoices store, we'd only be showing the data from the selected period.
            axios.get(url, {params:options}).then(resp => {
                this.selectedElement = resp.data.data;
                $('#invoicesModal').modal('show');
            });
            this.clickedElement = clickedElement;
        },

        resetForm(){
            this.editinvoice = false;
            this.invoiceoriginal = null;
            this.invoice = {};
        },

        saveNote() {
            let note = JSON.parse(JSON.stringify(this.note));
            axios.post(this.invoiceoriginal.paths.savenote, {note: note})
            .then(() => {
                this.invoiceoriginal.notes.push({
                    created_at: moment(),
                    user: Lang.get("global.me"),
                    note: note,
                });
                this.note = '';
            })
        },

        selectInvoiceToEdit(invoice) {
            this.invoiceoriginal = invoice;
            invoice = JSON.parse(JSON.stringify(invoice));
            invoice.date = moment(invoice.date).toDate();
            invoice.expected_at = moment(invoice.expected_at).toDate();
            if (invoice.paid_at !== '') {
                invoice.paid_at = moment(invoice.paid_at).toDate();
            }
            if (invoice.salesinvoice === false && this.date !== null) {
                invoice.date = moment(invoice.date).toDate();
            }
            this.invoice = invoice;
            this.editinvoice = true;
        },

        setProperAmount(newvalue, invoice) {
            invoice.amount = newvalue * 100;
        },

        setProperExpenses(newvalue, invoice) {
            invoice.expenses = newvalue * 100;
        },

    },

    mounted() {
        this.setInvoiceOptions();
    },

    name: "BusinessInvoiceModal",

}

</script>

<style>

    .invoicenote {
        padding: 10px 0;
        border-top:2px solid #ccc;
    }

</style>
